import React from "react";

import Dialog from "./Dialog";
import { useApi } from "../../../../api";
import { setFieldErrorsFromResponse } from "../../../../utils/formErrors";
import MaintenanceForm from "../Form/MaintenanceForm";
import { MAINTENANCE_PRIORITY } from "../../../../domain/maintenance";
import useI18nSnackbar from "../../../../hooks/useI18nSnackbar";
import { format } from "date-fns";

const CreateContainer = ({ device, onClose }) => {
  const api = useApi();
  const { enqueueSnackbar } = useI18nSnackbar();

  const handleSubmit = (values, { setSubmitting, setFieldError }) => {
    console.log(values);
    const params = {
      deviceId: device.id,
      title: values.title,
      description: values.description,
      priority: values.priority,
      technician: values.technician,
      maintenanceInterval: values.maintenanceInterval,
      maintenanceAt: values.maintenanceAt
        ? format(new Date(values.maintenanceAt), "yyyy-MM-dd")
        : null
    };

    api
      .post("/v2/maintenance", params)
      .then(() => {
        enqueueSnackbar("devices.maintenance.responses.created", {
          variant: "success"
        });

        onClose(true);
      })
      .catch(e => {
        if (!e.response) {
          return;
        }

        setSubmitting(false);
        setFieldErrorsFromResponse(e.response, setFieldError);
      });
  };

  const values = {
    title: "",
    description: "",
    priority: MAINTENANCE_PRIORITY.MEDIUM,
    technician: "",
    maintenanceInterval: 90,
    maintenanceAt: new Date()
  };

  const handleCancel = () => onClose();

  return (
    <Dialog onClose={handleCancel}>
      <MaintenanceForm
        values={values}
        onClose={handleCancel}
        onSubmit={handleSubmit}
      />
    </Dialog>
  );
};

export default CreateContainer;
